var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import React from "react";
// @ts-ignore
import SvgIcon from "@mui/material/SvgIcon";
var CloudUploadIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("g", { "clip-path": "url(#a)", transform: "translate(0 4)" },
        React.createElement("path", { fill: "currentColor", d: "M0 0h24v16H0V0z" })))); };
export default CloudUploadIcon;
